import { createSlice } from "@reduxjs/toolkit"
import { WEBCHAT_QUEUE_ANALYTICS } from "../../../../constants/reducer_names"

const initialState = {
    checked_column: [
        "Queue Name",
        "Received Chats",
        "Responded Chats",
        "Abandoned Chats",
        "Missed Chats",
        "Transferred Chats",
        "Total chat duration",
        "Avg. chat duration",
        "Interactions from Customer",
        "Interactions from Agent",
        "Total Interactions"
    ] as any,
    checked_column2: [
        "Queue Name",
        "Avg. Response Time",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        "Total ACW Time",
        "Avg. Hold Time",
        "Avg. Queue Wait Time",
        "Maximum Queue Wait Time",
        "Occupancy Rate (%)",
        "First Chat Resolution (%)",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column3: [
        "Queue Name",
        "Chat Type",
        "SL1",
        "SL2",
        "SL3",
        "SL4",
        "SL5",
        "SL6",
        "Total",
        "Missed Chats",
        "SLA Achieved (%)",
        "SLA Breached (%)"
    ] as any,
    titleMapper_ForDb: {
        "Queue Name": "queueName",
        "Received Chats": "receivedchats",
        "Responded Chats": "responseTime",
        "Abandoned Chats": "abondedchats",
        "Missed Chats": "MissedChat",
        "Transferred Chats": "transferredchat",
        "Total chat duration": "totalChatduration",
        "Avg. chat duration": "avgChatduration",
        "Interactions from Customer": "interactionfromcustomer",
        "Interactions from Agent": "interactionfromagent",
        "Total Interactions": "totalinteraction"
    } as any,
    titleMapper_ForDb2: {
        "Queue Name": "queueName",
        "Avg. Response Time": "AverageresponseTime",
        "Avg. Handle Time (AHT)": "AverageHandledTime",
        "Maximum Handle Time": "MaximumHandledTime",
        "Total ACW Time": "TotalACW",
        "Avg. Hold Time": "AverageQueueWaiting",
        "Avg. Queue Wait Time": "AverageQueueWaiting",
        "Maximum Queue Wait Time": "MaximumQueueWaiting",
        "Occupancy Rate (%)": "occupancyrate",
        "First Chat Resolution (%)": "firstChatResolution",
        "Customer Satisfaction (%)": "CustomerSatisfaction"
    } as any,
    titleMapper_ForDb3: {
        "Queue Name": "queueName",
        "Chat Type": "ChatType",
        "SL1": "SL1",
        "SL2": "SL2",
        "SL3": "SL3",
        "SL4": "SL4",
        "SL5": "SL5",
        "SL6": "SL6",
        "Total": "Total",
        "Missed Chats": "MissedChats",
        "SLA Achieved (%)": "SLAAchieved",
        "SLA Breached (%)": "SLAbreached"
    } as any,
    updated_TableColumn: [
        {
            title: 'Queue Name',
            dataIndex: 'queueName',
            key: 'queueName',
        },

        {
            title: 'Received Chats',
            dataIndex: 'receivedchats',
            key: 'receivedchats',
        },
        {
            title: 'Responded Chats',
            dataIndex: 'responseTime',
            key: 'responseTime',
        },
        {
            title: 'Abandoned Chats',
            dataIndex: 'abondedchats',
            key: 'abondedchats',
        },
        {
            title: 'Missed Chats',
            dataIndex: 'MissedChat',
            key: 'MissedChat',
        },
        {
            title: 'Transferred Chats',
            dataIndex: 'transferredchat',
            key: 'transferredchat',
        },
        {
            title: 'Total chat duration',
            dataIndex: 'totalChatduration',
            key: 'totalChatduration',
        },
        {
            title: 'Avg. chat duration',
            dataIndex: 'avgChatduration',
            key: 'avgChatduration',
        },
        {
            title: 'Interactions from Customer',
            dataIndex: 'interactionfromcustomer',
            key: 'interactionfromcustomer',
        },
        {
            title: 'Interactions from Agent',
            dataIndex: 'interactionfromagent',
            key: 'interactionfromagent',
        },
        {
            title: 'Total Interactions',
            dataIndex: 'totalinteraction',
            key: 'totalinteraction',
        }
    ] as any,
    updated_TableColumn2: [
        {
            title: 'Queue Name',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Avg. Response Time',
            dataIndex: 'AverageresponseTime',
            key: 'AverageresponseTime',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'AverageHandledTime',
            key: 'AverageHandledTime',
        },
        {
            title: '% Max Handle Time',
            dataIndex: 'MaximumHandledTime',
            key: 'MaximumHandledTime',
        },
        {
            title: 'Total ACW Time',
            dataIndex: 'TotalACW',
            key: 'TotalACW',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'AverageQueueWaiting',
            key: 'AverageQueueWaiting',
        },
        {
            title: 'Avg. Queue Wait Time',
            dataIndex: 'AverageQueueWaiting',
            key: 'AverageQueueWaiting',
        },
        {
            title: 'Maximum Queue Wait Time',
            dataIndex: 'MaximumQueueWaiting',
            key: 'MaximumQueueWaiting',
        },
        {
            title: 'Occupancy Rate (%)',
            dataIndex: 'occupancyrate',
            key: 'occupancyrate',
        },
        {
            title: 'First Chat Resolution (%)',
            dataIndex: 'firstChatResolution',
            key: 'firstChatResolution',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'CustomerSatisfaction',
            key: 'CustomerSatisfaction',
        }
    ] as any,
    updated_TableColumn3: [
        {
            title: 'Queue Name',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Chat Type',
            dataIndex: 'ChatType',
            key: 'ChatType',
        },
        {
            title: 'SL1',
            dataIndex: 'SL1',
            key: 'SL1',
        },
        {
            title: 'SL2',
            dataIndex: 'SL2',
            key: 'SL2',
        },
        {
            title: 'SL3',
            dataIndex: 'SL3',
            key: 'SL3',
        },
        {
            title: 'SL4',
            dataIndex: 'SL4',
            key: 'SL4',
        },
        {
            title: 'SL5',
            dataIndex: 'SL5',
            key: 'SL5',
        },
        {
            title: 'SL6',
            dataIndex: 'SL6',
            key: 'SL6',
        },
        {
            title: 'Total',
            dataIndex: 'Total',
            key: 'Total',
        },
        {
            title: 'Missed Chats',
            dataIndex: 'MissedChats',
            key: 'MissedChats',
        },
        {
            title: 'SLA Achieved (%)',
            dataIndex: 'SLAAchieved',
            key: 'SLAAchieved',
        },
        {
            title: 'SLA Breached (%)',
            dataIndex: 'SLAbreached',
            key: 'SLAbreached',
        },
    ] as any
}

const queueAnalyticsWebchatSlice = createSlice({
    name: WEBCHAT_QUEUE_ANALYTICS,
    initialState,
    reducers: {
        checkedColumn: (state, { payload }) => {
            state.checked_column = payload.checked_column;
        },
        checkedColumn2: (state, { payload }) => {
            state.checked_column2 = payload.checked_column2;
        },
        checkedColumn3: (state, { payload }) => {
            state.checked_column3 = payload.checked_column3;
        },
        titleMapperForDb: (state, { payload }) => {
            state.titleMapper_ForDb = payload.titleMapper_ForDb;
        },
        titleMapperForDb2: (state, { payload }) => {
            state.titleMapper_ForDb2 = payload.titleMapper_ForDb2;
        },
        titleMapperForDb3: (state, { payload }) => {
            state.titleMapper_ForDb3 = payload.titleMapper_ForDb3;
        },
        updatedTableColumn: (state, { payload }) => {
            state.updated_TableColumn = payload.updated_TableColumn;
        },
        updatedTableColumn2: (state, { payload }) => {
            state.updated_TableColumn2 = payload.updated_TableColumn2;
        },
        updatedTableColumn3: (state, { payload }) => {
            state.updated_TableColumn3 = payload.updated_TableColumn3;
        },


    }
})

export const queueAnalyticsWebchatSliceActions = queueAnalyticsWebchatSlice.actions;
export const queueAnalyticsWebchatSliceReducer = queueAnalyticsWebchatSlice.reducer